// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__2f4pq","text":"SelectPayment_text__3dOki","title":"SelectPayment_title__2wRfu","btn":"SelectPayment_btn__N2rMN"};